angular.module('tgaAdmin').config(['momentPickerProvider',
  function (momentPickerProvider) {
    momentPickerProvider.options({
      hoursFormat: 'h a',
    });
  },
]);
